import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { GedDesignerFormComponent } from './ged-designer-form/ged-designer-form.component';
import { DynamicGedDesignerComponent } from './dynamic-ged-designer.component';
import { IonicModule } from '@ionic/angular';
import { MaterialModule } from '../../material.module';
import { GedDesignerModalComponent } from './ged-designer-modal/ged-designer-modal.component';

@NgModule({
    declarations: [
        GedDesignerFormComponent, GedDesignerModalComponent, DynamicGedDesignerComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule
    ],
    entryComponents: [
        DynamicGedDesignerComponent,
        GedDesignerModalComponent
    ]
})
export class GedDesignerModule {}